import angular from 'angular';


export default angular.module('app.services.featureFlagsHelper', [
  'feature-flags'
])
  .service('featureFlagsHelper', function (featureFlags) {
    this.getFlagByKey = function (featureFlagKey) {
        let flag = _.filter(featureFlags.get(), (flag) => {
          return flag.key == featureFlagKey;
        })[0];
        return flag || {active: false};
    };

    return this;
  });


/** WEBPACK FOOTER **
 ** ./src/services/featureFlagsHelper.js
 **/